import Reveal from "@/components/Reveal";
import Cta from "@/components/Cta";
import { Icon } from "@/components/Icon";
import { ABOUT_HIGHLIGHTS, IMAGES, COMPANY } from "@/lib/content";

const AboutPreview = () => {
  return (
    <section className="bg-white" data-testid="about-preview">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <Reveal className="lg:col-span-5">
            <div className="rounded-lg overflow-hidden shadow-[0_20px_50px_-24px_rgba(36,59,99,0.3)] border border-[#2A2E7A]/5">
              <img
                src={IMAGES.about}
                alt="Accountant analyzing financial growth using a calculator"
                className="w-full h-[400px] lg:h-[480px] object-cover"
                loading="lazy"
              />
            </div>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-7">
            <p className="text-[13px] font-semibold uppercase tracking-[0.18em] text-[#4B5CAB]">
              About Best Bizz Financial
            </p>
            <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-bold tracking-[-0.02em] text-[#2A2E7A] leading-[1.15]">
              A trusted financial partner for Aruban businesses since {COMPANY.since}
            </h2>
            <p className="mt-6 text-[17px] text-[#51607A] leading-[1.8]">
              We provide accounting, bookkeeping, payroll and consultancy
              services built around personal attention and dependable results.
              Our clients stay with us because we keep their finances accurate,
              their reporting clear and their costs predictable.
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4">
              {ABOUT_HIGHLIGHTS.map((h) => (
                <div key={h.label} className="flex items-center gap-3.5">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[7px] bg-[#F5F6FB] border border-[#2A2E7A]/8">
                    <Icon name={h.icon} className="h-5 w-5 text-[#4B5CAB]" strokeWidth={1.6} />
                  </span>
                  <span className="text-[15px] font-medium text-[#2A2E7A]">{h.label}</span>
                </div>
              ))}
            </div>

            <div className="mt-9">
              <Cta to="/about" variant="secondary" withArrow testId="about-preview-learn-more">
                Learn More
              </Cta>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;
